(function () {
  'use strict';

  let angular = window.angular;

  const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  ProfileEditController.$inject = ['$scope', 'SupportAdmin', 'Var', 'AppUtils'];

  angular.module('app').component('supportAdminForm', {
    template:'<form name="$ctrl.updateForm" class="validate" novalidate autocomplete="off"><div class="modal-header"><span translate ng-if="$ctrl.user.id">form.actions.edit</span> <span translate ng-if="!$ctrl.user.id">form.actions.create</span> <span translate>entities.user.modelName</span></div><div class="modal-body"><div class="row"><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="name-input" translate>entities._all.name</label> <input id="name-input" name="nameInput" ng-model="$ctrl.user.name" translate-attr="::{placeholder: \'entities._all.name\'}" class="form-control input-sm" required><p class="help-block" ng-messages="$ctrl.updateForm.nameInput.$error"><span ng-message="required" translate>form.errors.required</span></p></div></div><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="surname-input" translate>entities._all.surname</label> <input id="surname-input" name="surnameInput" ng-model="$ctrl.user.surname" translate-attr="::{placeholder: \'entities.user.surname\'}" class="form-control input-sm" required><p class="help-block" ng-messages="$ctrl.updateForm.surnameInput.$error"><span ng-message="required" translate>form.errors.required</span></p></div></div><div class="col-md-6"><div class="form-group" show-errors><label for="email-input" class="control-label" translate>entities._all.email</label> <input type="email" id="email-input" name="emailInput" ng-model="$ctrl.user.email" maxlength="254" pattern="^(?:[A-Za-z][A-Za-z.\\d_\\-]*[A-Za-z\\d]{2,64}|[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,6})$" translate-attr="::{placeholder: \'entities._all.email\'}" class="form-control input-sm" required><p class="help-block" ng-messages="$ctrl.updateForm.emailInput.$error" ng-if="$ctrl.updateForm.emailInput.$error"><span ng-message="required" translate>form.errors.required</span> <span ng-message="email" translate>form.errors.email</span></p></div></div><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="username-input" translate>entities._all.username</label> <input id="username-input" name="usernameInput" ng-model="$ctrl.user.username" maxlength="64" pattern="^(?:[A-Za-z][A-Za-z.\\d_\\-]*[A-Za-z\\d]{2,64}|[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,6})$" translate-attr="::{placeholder: \'entities._all.username\'}" class="form-control input-sm" required><p class="help-block" ng-messages="$ctrl.updateForm.usernameInput.$error" ng-if="$ctrl.updateForm.usernameInput.$error"><span ng-message="required" translate>form.errors.required</span></p></div></div><div class="col-md-12"><div class="form-group" show-errors><label class="control-label" translate>entities.organization.var.modelNamePl</label><ui-select multiple ng-model="$ctrl.selectedVars" theme="bootstrap" close-on-select="false" title="Seleccione uno o más roles"><ui-select-match translate-attr="::{placeholder: \'entities.organization.actions.selectVars\'}">{{$item.name}}</ui-select-match><ui-select-choices repeat="var in $ctrl.resolve.vars | filter:$select.search track by var.id"><div ng-bind="var.name"></div></ui-select-choices></ui-select></div></div><div ng-if="!$ctrl.user.id && !$ctrl.passwordRequired"><div class="col-md-12"><div class="form-group"><label class="checkbox" style="display: inline-block; width: auto"><input type="checkbox" ng-model="$ctrl.setPassword"> <i></i></label> <span translate>entities.user.password.setPassword</span> <span class="fas fa-fw fa-info-circle" style="font-size: 90%; vertical-align: super" uib-tooltip="{{\'entities.user.password.setPasswordInfo\' | translate}}" tooltip-placement="bottom"></span></div></div></div><div ng-if="!$ctrl.user.id && $ctrl.passwordRequired"><div class="col-md-12"><p class="help-block" translate>entities.user.password.passwordRequired</p></div></div><div ng-if="!$ctrl.user.id && $ctrl.setPassword"><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="password" translate>entities._all.password</label> <input id="password" type="password" name="password" autocomplete="new-password" translate-attr="::{placeholder: \'entities._all.password\'}" ng-model="$ctrl.user.password" ng-change="$ctrl.onPasswordChange()" ng-blur="$ctrl.onBlurPassword()" ng-required="$ctrl.setPassword" ng-minlength="$ctrl.minPassLength" class="form-control"><p class="help-block" ng-messages="$ctrl.updateForm.password.$error"><span ng-message="required" translate>form.errors.required</span> <span ng-message="minlength" translate>form.errors.minLength</span> <span ng-message="weak" translate>entities.user.password.weak</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div></div><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="confirmPassword" translate>entities.user.password.confirm</label> <input id="confirmPassword" type="password" name="confirmPassword" autocomplete="new-password" translate-attr="::{placeholder: \'entities.user.password.confirm\'}" ng-model="$ctrl.user.confirmPassword" ng-change="$ctrl.onPasswordChange()" ng-blur="$ctrl.onBlurPassword()" ng-required="$ctrl.setPassword" ng-minlength="$ctrl.minPassLength" class="form-control"><p class="help-block" ng-messages="$ctrl.updateForm.confirmPassword.$error"><span ng-message="required" translate>form.errors.required</span> <span ng-message="minlength" translate>form.errors.minLength</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div></div><div class="col-md-12"><ul class="list-unstyled marginB10" style="font-size: 12px"><li ng-class="$ctrl.requirements.length ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.length ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLength</span></li><li ng-class="$ctrl.requirements.upper ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.upper ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqUpper</span></li><li ng-class="$ctrl.requirements.lower ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.lower ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLower</span></li><li ng-class="$ctrl.requirements.digit ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.digit ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqDigit</span></li><li ng-class="$ctrl.requirements.symbol ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="$ctrl.requirements.symbol ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqSymbol</span></li></ul></div></div></div></div><div class="alert alert-warning no-margin text-center" ng-show="$ctrl.saveError">{{$ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="$ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-click="$ctrl.saveProfile()" ng-disabled="$ctrl.loading" translate>buttons.save</button></div></form><div style="position: relative; height: 400px" ng-show="$ctrl.saving"><spinner css-class="\'small\'" show="$ctrl.saving"></spinner></div>',
    controller: ProfileEditController,
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function ProfileEditController($scope, SupportAdmin, Var, utils) {
    let vm = this;
    vm.$onInit = function onInit() {
      vm.user = angular.copy(vm.resolve.user);
      vm.selectedVars = vm.user.vars || [];
      vm.isEdit = vm.user.id ? true : false;
      vm.passwordRequired = false;
      vm.setPassword = false;
      vm.minPassLength = 8;
      vm.requirements = { length: false, upper: false, lower: false, digit: false, symbol: false };
      vm.saveProfile = saveProfile;
      vm.onBlurPassword = onBlur;
      vm.onPasswordChange = onPasswordChange;
      vm.loading = false;

      if (!vm.user.id) {
        vm.loading = true;
        utils
          .getEmailVerificationRequired('SupportAdmins')
          .then((required) => {
            vm.passwordRequired = required === false;
            vm.setPassword = vm.passwordRequired;
            vm.loading = false;
          })
          .catch((err) => {
            console.log(err);
            vm.loading = false;
          });
      }
    };

    function onBlur() {
      if (!vm.setPassword) {
        return;
      }

      let password = vm.user.password;
      let repeatPassword = vm.user.confirmPassword;

      if (password && repeatPassword && password !== repeatPassword) {
        vm.updateForm.password.$setValidity('password_mismatch', false);
        vm.updateForm.confirmPassword.$setValidity('password_mismatch', false);
      } else {
        vm.updateForm.password.$setValidity('password_mismatch', true);
        vm.updateForm.confirmPassword.$setValidity('password_mismatch', true);
      }
    }

    function onPasswordChange() {
      if (!vm.setPassword) {
        return;
      }

      const password = vm.user.password || '';
      const repeatPassword = vm.user.confirmPassword || '';

      vm.requirements.length = password.length >= vm.minPassLength;
      vm.requirements.upper = /[A-Z]/.test(password);
      vm.requirements.lower = /[a-z]/.test(password);
      vm.requirements.digit = /\d/.test(password);
      vm.requirements.symbol = /[^A-Za-z0-9]/.test(password);

      if (!password || !repeatPassword || password === repeatPassword) {
        vm.updateForm.password.$setValidity('password_mismatch', true);
        vm.updateForm.confirmPassword.$setValidity('password_mismatch', true);
      }
      vm.updateForm.password.$setValidity('weak', true);
    }

    function saveProfile() {
      if (vm.loading) {
        return;
      }

      if (!vm.user.id && vm.setPassword && vm.user.password !== vm.user.confirmPassword) {
        vm.updateForm.password.$setValidity('password_mismatch', false);
        vm.updateForm.confirmPassword.$setValidity('password_mismatch', false);
      }

      if (!vm.user.id && vm.setPassword) {
        vm.updateForm.password.$setValidity(
          'weak',
          STRONG_PASSWORD_REGEX.test(vm.user.password || '')
        );
      }

      if (!vm.updateForm.$valid) {
        $scope.$broadcast('show-errors-check-validity');
        return;
      }

      let promise;

      if (vm.user.id) {
        promise = SupportAdmin.prototype$patchAttributes(
          {
            id: vm.user.id,
          },
          {
            name: vm.user.name,
            surname: vm.user.surname,
          }
        ).$promise;
      } else {
        const newSupportAdmin = {
          name: vm.user.name,
          surname: vm.user.surname,
          email: vm.user.email,
          username: vm.user.username,
        };

        if (vm.setPassword) {
          newSupportAdmin.password = vm.user.password;
        }

        promise = SupportAdmin.create(newSupportAdmin).$promise;
      }

      promise
        .then((supportAdmin) => {
          vm.user.id = supportAdmin.id;

          return updateSupportAdminVars();
        })
        .then(() => {
          vm.modalInstance.close(vm.user);
        })
        .catch((err) => {
          console.log(err);
          vm.saveError = utils.getHTTPError(err);
        });
    }

    function updateSupportAdminVars() {
      const oldVars = vm.user.vars || [];
      const newVars = vm.selectedVars || [];

      const oldIds = oldVars.map((v) => v.id);
      const newIds = newVars.map((v) => v.id);

      const varsToAdd = newIds.filter((id) => !oldIds.includes(id));
      const varsToRemove = oldIds.filter((id) => !newIds.includes(id));

      const supportAdminId = vm.user.id;

      const addPromises = varsToAdd.map((varId) => {
        return Var.prototype$__link__supportAdmins({ id: varId, fk: supportAdminId }, {}).$promise;
      });

      const removePromises = varsToRemove.map((varId) => {
        return Var.prototype$__unlink__supportAdmins({ id: varId, fk: supportAdminId }, {})
          .$promise;
      });

      return Promise.all([...addPromises, ...removePromises]);
    }
  }
})();
